import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ProgressArc from 'progress-arc-component';

import { Theme } from '../../config/theme.js';

import SearchField from '../SearchField';
import ArticleSummary from '../ArticleSummary';
import ButtonConfirm from '../ButtonConfirm';
import ButtonDeny from '../ButtonDeny';

const CLOSE_ICON = require('./close.svg');

export default class NextSongModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      goToNextSong: true,
    };
  }

  componentDidUpdate() {
    const timeRemaining = this.props.player.time_remaining;
    if (this.state.goToNextSong && timeRemaining === 0) {
      this._nextSong();
    }
  }

  _closeOverlay() {
    this.setState({
      goToNextSong: false,
    });

    this.props.dispatch({
      type: 'SET_SHOW_NEXT_SONG_MODAL',
      payload: false,
    });

    this.props.dispatch({
      type: 'SET_NEXT_SONG',
      payload: null,
    });
  }

  _nextSong() {
    if (this.props.player.next_song && this.props.player.next_song.article_url && this.props.player.next_song.state) {
      this.props.history.push(this.props.player.next_song.article_url);
      this.props.dispatch({
        type: 'SET_NEXT_SONG_STATE',
        payload: this.props.player.next_song.state,
      });
      this._closeOverlay();
    }
  }

  render() {
    const RedArc = styled(ProgressArc)`
      height: 12em;
      width: 12em;
      padding: 1em;
    `;

    const timeRemaining = this.props.player.time_remaining;
    // const timeRemaining = 8;

    return (
      <div className={css(styles.overlay_container)}>
        <div className={css(styles.clickable_container)} onClick={this._closeOverlay.bind(this)} />
        <div className={css(styles.container)}>
          <div onClick={this._closeOverlay.bind(this)} className={css(styles.close_container)}>
            <div className={css(styles.close_text)}>close</div> <img src={CLOSE_ICON} className={css(styles.close_icon)} />
          </div>
          <div className={css(styles.articles_container)}>
            <div className={css(styles.arc_container)}>
              <RedArc
                value={100 - (100 - (timeRemaining * 10))}
                arcColor={Theme.yellow}
                textVisible={false}
                rounded={true}
              />
              {timeRemaining > 0 && timeRemaining <= 10 ? (
                <div className={css(styles.countTimeRemaining)}>
                  {timeRemaining}
                </div>
              ) : false}
            </div>
            <p className={css(styles.para)}>Looks like the song is about to finish!</p>
            <p className={css(styles.para)}><strong>{this.props.player.next_song.article_title}</strong> will automatically play next.</p>

            <div className={css(styles.buttons)}>
              <ButtonDeny title="No thanks" handler={this._closeOverlay.bind(this)} />
              <div className={css(styles.spacer)} />
              <ButtonConfirm title="Play now" handler={this._nextSong.bind(this)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  overlay_container: {
    position: 'fixed',
    zIndex: 100,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(5,9,14,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    position: 'relative',
    zIndex: 10,
    padding: '40px 50px 40px',
    width: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    borderRadius: 5,
    boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'solid 1px #e4e4e4',
  },
  buttons: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'row',
  },
  spacer: {
    backgroundColor: 'transparent',
    height: 30,
    width: 30,
  },
  arc_container: {
    position: 'relative',
  },
  countTimeRemaining: {
    position: 'absolute',
    left: (224 / 2 )- 40,
    top: (224 / 2 ),
    width: 80,
    height: 80,
    textAlign: 'center',
    fontFamily: Theme.fontFamily,
    fontSize: 50,
    fontWeight: 'bold',
  },
  para: {
    display: 'block',
    fontFamily: Theme.fontFamily,
    marginBottom: 20,
    textAlign: 'center',
  },
  clickable_container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  close_container: {
    position: 'absolute',
    top: -40,
    right: 0,
    textAlign: 'right',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.5,
    },
  },
  close_text: {
    display: 'inline-block',
    fontFamily: Theme.fontFamily,
    letterSpacing: 1,
    fontSize: 14,
    color: Theme.white,
  },
  close_icon: {
    position: 'relative',
    top: 1,
    width: 10,
    height: 10,
  },
  search_container: {
    display: 'flex',
    marginRight: 30,
    borderBottom: `1px solid ${Theme.grey}`,
    alignItems: 'center',
  },
  search_icon_container: {
    flex: 1,
  },
  search_icon: {
    marginRight: 30,
    marginBottom: 10,
  },
  'search_input_container': {
    flex: 9,
  },
  articles_container: {
    paddingTop: 30,
    paddingBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap",
    flexDirection: 'column',
  },
  num_results: {
    display: 'block',
    marginTop: 30,
  },
  num_results_text: {
    fontFamily: Theme.fontFamily,
    color: Theme.white,
    fontSize: 10,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
  load_more_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});



// WEBPACK FOOTER //
// ./src/components/NextSongModal/index.js